/** @format */

import React from "react";

export const columns = [
  {
    dataField: "id",
    text: "No",
    sort: true,
    align: "center",
    headerAlign: "center",
    formatter: (cellContent, row, index) => {
      return <div>{index + 1}</div>;
    },
    style: {
      fontSize: "13px",
      color: "#888",
    },
    headerStyle: () => {
      return { width: "10%" };
    },
  },
  {
    dataField: "status",
    text: "상태",
    sort: true,
    align: "center",
    headerAlign: "center",
    style: {
      fontSize: "13px",
      fontWeight: "bold",
      color: "#f96868",
    },
    headerStyle: () => {
      return { width: "15%" };
    },
  },
  {
    dataField: "title",
    text: "제목",
    sort: true,
    align: "start",
    headerAlign: "center",
    formatter: (cellContent) => {
      return <div className="truncate-2-lines">{cellContent}</div>;
    },
    style: {
      fontSize: "13px",
      color: "#333",
      lineHeight: "1.7",
    },
    headerStyle: () => {
      return { width: "50%" };
    },
  },
  {
    dataField: "createdAt",
    text: "작성일",
    sort: true,
    align: "right",
    headerAlign: "center",
    style: {
      fontSize: "12px",
      color: "#333",
      lineHeight: "1.7",
    },
    headerStyle: () => {
      return { width: "25%" };
    },
  },
];
